import {
  createColumnDate,
  createColumnNumber,
  createColumnText,
  widthOptions,
} from '../../../components/table/function';

const parseMobiles = (mobiles) => {
  if (!mobiles) return [];
  let list = mobiles;
  if (typeof list === 'string') {
    try {
      list = JSON.parse(list);
    } catch {
      return [];
    }
  }
  if (!Array.isArray(list)) return [];
  return [...list].sort((a, b) => (Number(a?.seq) || 0) - (Number(b?.seq) || 0));
};

export const getWarrantyMobileBrandsDisplay = (record) => {
  const list = parseMobiles(record?.mobiles);
  if (list.length > 0) {
    const line = list.map((m) => (m?.mobileBrandName ?? '').trim()).join(' | ');
    if (line.trim()) return line;
  }
  return (record?.mobileBrandName ?? '').trim();
};

export const getWarrantyMobileModelsDisplay = (record) => {
  const list = parseMobiles(record?.mobiles);
  if (list.length > 0) {
    const line = list.map((m) => (m?.mobileModelName ?? '').trim()).join(' | ');
    if (line.trim()) return line;
  }
  return (record?.mobileModelName ?? '').trim();
};

export const columns = () => {
  return [
    {
      ...createColumnText('ชื่อ-นามสกุล', 'fullname', widthOptions(150)),
      render: (text, record) => (
        <span style={{ color: record?.totalWarranty > 5 ? '#ff4d4f' : '#000' }}>{text}</span>
      ),
    },

    {
      ...createColumnText('เบอร์โทร', 'telephone', widthOptions(95)),
      render: (text, record) => (
        <span style={{ color: record?.totalWarranty > 5 ? '#ff4d4f' : '#000' }}>{text}</span>
      ),
    },
    {
      ...createColumnNumber('จำนวนการลงทะเบียน', 'totalWarranty', widthOptions(110)),
      sorter: (a, b) => a.totalWarranty - b.totalWarranty,
      defaultSortOrder: 'descend',
      render: (text, record) => (
        <span style={{ color: record?.totalWarranty > 5 ? '#ff4d4f' : '#000' }}>{text}</span>
      ),
    },
    {
      ...createColumnDate('วันที่ลงทะเบียนล่าสุด', 'lastWarrantyDate', widthOptions(150)),
      render: (text, record) => (
        <span style={{ color: record?.totalWarranty > 5 ? '#ff4d4f' : '#000' }}>{text}</span>
      ),
    },
  ];
};

export const columnsExpandable = () => {
  return [
    createColumnText('เลขที่รับประกัน', 'warrantyCode', widthOptions(150)),
    createColumnText('รหัสรับประกัน', 'warrantyNumberCode', widthOptions(150)),
    createColumnDate('รหัสลูกค้า', 'customerCode', widthOptions(150)),
    {
      ...createColumnText('ยี่ห้อ', 'mobileBrandName', widthOptions(150)),
      render: (_, record) => getWarrantyMobileBrandsDisplay(record),
    },
    {
      ...createColumnText('รุ่น', 'mobileModelName', widthOptions(150)),
      render: (_, record) => getWarrantyMobileModelsDisplay(record),
    },
    createColumnText('ชื่อสินค้า', 'productName', widthOptions(150)),
    createColumnText('รหัสสินค้า', 'itemCode', widthOptions(150)),
    createColumnText('ประเภทสินค้า', 'productTypeCode', widthOptions(150)),
    createColumnText('ช่องทางการซื้อขาย', 'channelBuyNameTh', widthOptions(150)),
    createColumnText('วันที่ลงทะเบียน', 'createDate', widthOptions(150)),
  ];
};
